import { render, staticRenderFns } from "./FaltantesAbiertosTable.vue?vue&type=template&id=273cfff7"
import script from "./FaltantesAbiertosTable.vue?vue&type=script&lang=js"
export * from "./FaltantesAbiertosTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports